namespace appn.views.data.mapEntry {

    class InitArgs {
        userLatLon: string = appn.emptyString;
    }

    const _entryLayers: L.Marker[] = [];
    let _initArgs: InitArgs;
    let _map: L.Map;

    export function init(args: InitArgs) {
        _initArgs = args;

        // Resize map div to take up all available height
        const availableHeight = $('#content').height();
        let setHeight = (availableHeight === undefined) ? 200 : availableHeight;
        setHeight -= 10;
        $('#map').height(setHeight);

        // Load the map
        initMap();
    }

    appn.pubSub.subscribe(appn.pubSub.WINDOW_RESIZED, function(channel: string, data: any) {
        if (!_map)
            return;

        _map.invalidateSize();
    });

    function initMap() {
        _map = appn.ui.mapInit('map', 0, 0, 11, false);

        const userLatLon = _initArgs.userLatLon.split(',');
        const userLat: number = userLatLon[0] as any;
        const userLon: number = userLatLon[1] as any;
        let lastEntryLatLng = new L.LatLng(userLat, userLon); // Default to user country
        let lastPopup;

        // process the geo entries onto the map
        $('#entryData .infoField').each(function(index) {
            const display = $(this).find('.displayText');
            const lat = display.data('lat');
            const lon = display.data('lon');

            // Exclude 0,0 lat/lon since this is a fail to capture GPS on device
            if (lat !== 0 && lon !== 0) {
                const entriesll = new L.LatLng(lat, lon, 1); // altitude originally set to 'true'
                const icon = L.divIcon({
                    html: '<div class="appn-mapPin"></div><div class="appn-mapShadow"></div>'
                });
                const entriesmark = new L.Marker(entriesll, { icon: icon });

                _map.addLayer(entriesmark);
                _entryLayers.push(entriesmark);

                const popupText = `<div class="appnMapPopup">
                                    <h5>Captured Here</h5>${display.text().trim()}
                                    <span class="text-muted leaflet-popup-gpsstring">
                                    <i class="fa fa-map-marker"></i> ${lat} ${lon}</span><br>
                                </div>`;

                lastPopup = entriesmark.bindPopup(popupText);
                lastEntryLatLng = entriesll;
                lastPopup.openPopup();
            }
        });

        _map.setView(lastEntryLatLng, 13);
    }

}
